import * as i0 from '@angular/core';
import { Injectable, RendererFactory2, Inject, Component, ViewChild, ElementRef, InjectionToken, EventEmitter, Input, Output, Pipe, NgModule, Directive, TemplateRef, ViewContainerRef, Renderer2 } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClient, HttpErrorResponse, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { of, BehaviorSubject, Subject, from, interval, forkJoin, Observable, throwError } from 'rxjs';
import * as i6$1 from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as i2 from '@angular/router';
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationCancel, NavigationStart, Router, RouterModule } from '@angular/router';
import * as i6 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import { __awaiter } from 'tslib';
import { DomSanitizer } from '@angular/platform-browser';
import { IframeResizerModule } from '@stg-js-ngx-core/iframe-resizer';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
import * as ɵngcc2 from '@angular/router';
import * as ɵngcc3 from '@ng-bootstrap/ng-bootstrap';
import * as ɵngcc4 from '@angular/platform-browser';
import * as ɵngcc5 from '@angular/common';
import * as ɵngcc6 from '@stg-js-ngx-core/iframe-resizer';

const _c0 = ["reauthIframe"];
function UserAdministrationComponent_iframe_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "iframe", 1);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r0.userAdminUrl, ɵngcc0.ɵɵsanitizeResourceUrl);
} }
const UrlSpace = {
    urls: {
        oAuthProfile: '/api/users/oauthProfile',
        clientLogger: '/api/client/logger',
        rbacUserProfileForRole: '/api/users/profiles',
        applicationConfiguration: '/api/application/configuration',
        teamsHierarchy: '/api/users/applications/{application}/roles/{role}/hierarchicalteams',
        hierarchyTeam: '/api/hierarchy/{teamName}',
        userAdminUI: '/ui/#useradministration?menu=false&appName={appName}&roleName={roleName}&rbac_app_name={rbac_app_name}&rbac_role_name={rbac_role_name}&access_attributes={access_attributes}&hierarchyType={hierarchyType}',
    },
    serverlessUrlTemplates: {
        sso: {
            performOauthSignOn: '{sso_base_url}/oauth2.0/authorize?client_id={client_id}&redirect_uri={callback_uri}&response_type=code',
            getOauthProfileFromToken: '{sso_base_url}/oauth2.0/profile?access_token={token}'
        },
        rbac: {
            getRbacProfileForToken: '{adams_base_url}/api/users/profile?app_name={rbac_app_name}'
        }
    },
    urlRegexPatternsToIgnoreInOauthInterceptor: [
        /.*oauth2\.0\/.*/g,
        /.*\/api\/users\/profile.*/g
    ],
    headers: {
        contentType: {
            name: 'Content-Type',
            json: 'application/json',
            html: 'text/html',
            stream: 'application/octet-stream',
            form: 'application/x-www-form-urlencoded'
        }
    }
};

class OauthConfigService {
    constructor() { }
    configureServerlessOauth(config) {
        this._serverless = true;
        this._oauthClientId = config.clientId;
        this._rbacEnabled = config.rbacEnabled;
        this._rbacAppName = config.rbacAppName;
        this._revalidateAfterMin = config.revalidateAfterMin;
        this._sessionExpirationAlertInMin = config.sessionExpirationAlertInMin;
        this._longestTimeToLiveHours = config.longestTimeToLiveHours;
        this._autoLogoutOnSessionExpired = config.autoLogoutOnSessionExpired;
        this._logoutUrl = config.logoutUrl;
        this._environmentConfig = config.environmentConfig;
    }
    get oauthProfile() {
        return this._oauthProfile;
    }
    set oauthProfile(profile) {
        this._oauthProfile = profile;
    }
    get oauthToken() {
        return this._oauthToken;
    }
    set oauthToken(value) {
        this._oauthToken = value;
    }
    get isServerless() {
        return this._serverless;
    }
    get oauthClientId() {
        return this._oauthClientId;
    }
    get isRbacEnabled() {
        return this._rbacEnabled;
    }
    get rbacAppName() {
        return this._rbacAppName;
    }
    get revalidateAfterMin() {
        return this._revalidateAfterMin;
    }
    get sessionExpirationAlertInMin() {
        return this._sessionExpirationAlertInMin;
    }
    get longestTimeToLiveHours() {
        return this._longestTimeToLiveHours;
    }
    get autoLogoutOnSessionExpired() {
        return this._autoLogoutOnSessionExpired;
    }
    get logoutUrl() {
        return this._logoutUrl;
    }
    get environmentConfig() {
        return this._environmentConfig;
    }
}
OauthConfigService.ɵfac = function OauthConfigService_Factory(t) { return new (t || OauthConfigService)(); };
OauthConfigService.ɵprov = i0.ɵɵdefineInjectable({ factory: function OauthConfigService_Factory() { return new OauthConfigService(); }, token: OauthConfigService, providedIn: "root" });
OauthConfigService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OauthConfigService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class SsoService {
    constructor(http, oauthConfigService) {
        this.http = http;
        this.oauthConfigService = oauthConfigService;
    }
    performOAuthSingleSignOn() {
        const url = UrlSpace.serverlessUrlTemplates.sso.performOauthSignOn
            .replace('{sso_base_url}', this.oauthConfigService.environmentConfig.baseUrls.sso)
            .replace('{client_id}', encodeURI(this.oauthConfigService.oauthClientId))
            .replace('{callback_uri}', encodeURI(this.oauthConfigService.environmentConfig.baseUrls.oauthLambda));
        window.location.href = url;
    }
    getOauthProfileFromToken(token) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = UrlSpace.serverlessUrlTemplates.sso.getOauthProfileFromToken
                .replace('{sso_base_url}', this.oauthConfigService.environmentConfig.baseUrls.sso)
                .replace('{token}', token);
            const promise = new Promise((resolve, reject) => {
                this.http.get(url)
                    .toPromise()
                    .then(data => {
                    resolve(data);
                }, error => {
                    console.log('error :: ', error);
                    if (error.status === 401) {
                        this.performOAuthSingleSignOn();
                    }
                });
            });
            return promise;
        });
    }
}
SsoService.ɵfac = function SsoService_Factory(t) { return new (t || SsoService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(OauthConfigService)); };
SsoService.ɵprov = i0.ɵɵdefineInjectable({ factory: function SsoService_Factory() { return new SsoService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(OauthConfigService)); }, token: SsoService, providedIn: "root" });
SsoService.ctorParameters = () => [
    { type: HttpClient },
    { type: OauthConfigService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SsoService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: OauthConfigService }]; }, null); })();

class ServerlessRbacService {
    constructor(http, oauthConfigService) {
        this.http = http;
        this.oauthConfigService = oauthConfigService;
    }
    getRbacProfileForToken(token) {
        return __awaiter(this, void 0, void 0, function* () {
            console.error('RBAC Security support not currently available');
            return {};
            /*
            // TODO: adams is having an error with CORS - resolve that before using
            // TODO: abstract these parameters
            const rbacAppName = this.oauthConfigService.rbacAppName;
            const url = UrlSpace.serverlessUrlTemplates.rbac.getRbacProfileForToken
              .replace('{adams_base_url}', this.oauthConfigService.environmentConfig.baseUrls.rbac)
              .replace('{rbac_app_name}', rbacAppName);
        
            const headers = new HttpHeaders()
              .set('content-type', 'application/json')
              .set('access_token', token);
        
            const promise = new Promise((resolve, reject) => {
              this.http.get(url, { headers })
                .toPromise()
                .then(data => {
                    console.log('RBAC Profile from Token :: ', data);
                    resolve(data);
                  }
                );
            });
        
            return promise;
            */
        });
    }
}
ServerlessRbacService.ɵfac = function ServerlessRbacService_Factory(t) { return new (t || ServerlessRbacService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(OauthConfigService)); };
ServerlessRbacService.ɵprov = i0.ɵɵdefineInjectable({ factory: function ServerlessRbacService_Factory() { return new ServerlessRbacService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(OauthConfigService)); }, token: ServerlessRbacService, providedIn: "root" });
ServerlessRbacService.ctorParameters = () => [
    { type: HttpClient },
    { type: OauthConfigService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServerlessRbacService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: OauthConfigService }]; }, null); })();

class RbacProfileObject {
    constructor(oauthProfile, rbacProfile) {
        this._oauthProfile = oauthProfile;
        this._rbacProfile = rbacProfile;
    }
    getCombinedOauthRbacProfileObjectForResponse() {
        return {
            user_name: this.username,
            status: this.status,
            first_name: this.firstName,
            middle_name: this.middleName,
            last_name: this.lastName,
            email: this.email,
            primary_phone: this.primaryPhone,
            work_phone: this.workPhone,
            cost_center_name: this.costCenterName,
            cost_center_source_system_id: this.costCenterSourceSystemId,
            default_role: this.defaultRole,
            current_role: this.currentRole,
            all_roles: this.allRoles,
            secured_objects: this.securedObjects,
            profile_type: this.profileType,
            account_type: this.accountType,
            full_profile: this.fullProfile,
            teams: this.teams
        };
    }
    get username() {
        return this._oauthProfile.id ? this._oauthProfile.id : this._rbacProfile.user_name;
    }
    get status() {
        var _a;
        return ((_a = this._rbacProfile) === null || _a === void 0 ? void 0 : _a.status) ? this._rbacProfile.status : 'A';
    }
    get firstName() {
        var _a, _b;
        return ((_a = this._oauthProfile.attributes) === null || _a === void 0 ? void 0 : _a.first_name) ? this._oauthProfile.attributes.first_name : (_b = this._rbacProfile) === null || _b === void 0 ? void 0 : _b.first_name;
    }
    get middleName() {
        var _a, _b;
        return ((_a = this._oauthProfile.attributes) === null || _a === void 0 ? void 0 : _a.middle_name) ? this._oauthProfile.attributes.middle_name : (_b = this._rbacProfile) === null || _b === void 0 ? void 0 : _b.middle_name;
    }
    get lastName() {
        var _a, _b;
        return ((_a = this._oauthProfile.attributes) === null || _a === void 0 ? void 0 : _a.last_name) ? this._oauthProfile.attributes.last_name : (_b = this._rbacProfile) === null || _b === void 0 ? void 0 : _b.last_name;
    }
    get email() {
        var _a, _b;
        return ((_a = this._oauthProfile.attributes) === null || _a === void 0 ? void 0 : _a.email) ? this._oauthProfile.attributes.email : (_b = this._rbacProfile) === null || _b === void 0 ? void 0 : _b.email;
    }
    get primaryPhone() {
        var _a, _b;
        return ((_a = this._rbacProfile) === null || _a === void 0 ? void 0 : _a.primary_phone) ? this._rbacProfile.primary_phone : (_b = this._oauthProfile.attributes) === null || _b === void 0 ? void 0 : _b.telephone;
    }
    get workPhone() {
        var _a;
        return (_a = this._oauthProfile.attributes) === null || _a === void 0 ? void 0 : _a.telephone;
    }
    get costCenterName() {
        var _a, _b, _c;
        return ((_a = this._oauthProfile.attributes) === null || _a === void 0 ? void 0 : _a.cost_center) ? (_b = this._oauthProfile.attributes) === null || _b === void 0 ? void 0 : _b.cost_center : (_c = this._rbacProfile) === null || _c === void 0 ? void 0 : _c.cost_center;
    }
    get costCenterSourceSystemId() {
        var _a, _b;
        return ((_a = this._rbacProfile) === null || _a === void 0 ? void 0 : _a.cost_center_source_system_id) ? (_b = this._rbacProfile) === null || _b === void 0 ? void 0 : _b.cost_center_source_system_id : '';
    }
    get defaultRole() {
        var _a;
        return ((_a = this._rbacProfile) === null || _a === void 0 ? void 0 : _a.default_role) ? this._rbacProfile.default_role : {};
    }
    get currentRole() {
        var _a;
        return ((_a = this._rbacProfile) === null || _a === void 0 ? void 0 : _a.current_role) ? this._rbacProfile.current_role : {};
    }
    get allRoles() {
        var _a;
        return ((_a = this._rbacProfile) === null || _a === void 0 ? void 0 : _a.all_roles) ? this._rbacProfile.all_roles : [];
    }
    get securedObjects() {
        var _a;
        return ((_a = this._rbacProfile) === null || _a === void 0 ? void 0 : _a.secured_objects) ? this._rbacProfile.secured_objects : [];
    }
    get profileType() {
        var _a;
        return ((_a = this._rbacProfile) === null || _a === void 0 ? void 0 : _a.user_name) ? RbacService.PROFILE_TYPES.RBAC : RbacService.PROFILE_TYPES.OAUTH;
    }
    get accountType() {
        var _a;
        return (_a = this._oauthProfile.attributes) === null || _a === void 0 ? void 0 : _a.account_type;
    }
    get fullProfile() {
        return this.oauthProfile;
    }
    get teams() {
        var _a;
        return ((_a = this._rbacProfile) === null || _a === void 0 ? void 0 : _a.teams) ? this._rbacProfile.teams : [];
    }
    get oauthProfile() {
        return this._oauthProfile;
    }
    get rbacProfile() {
        return this._rbacProfile;
    }
}

class ServerlessOauthService {
    constructor(oauthConfigService, ssoService, serverlessRbacService) {
        this.oauthConfigService = oauthConfigService;
        this.ssoService = ssoService;
        this.serverlessRbacService = serverlessRbacService;
        const currentUrl = new URL(window.location.href);
        this.oauthConfigService.oauthToken = currentUrl.searchParams.get('token');
    }
    beginServerlessOauthHandling(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.oauthConfigService.configureServerlessOauth(config);
            if (this.hasExistingOauthToken()) {
                yield this.buildSecurityProfileBasedOnOauthToken();
                return true;
            }
            this.ssoService.performOAuthSingleSignOn();
            return false;
        });
    }
    hasExistingOauthToken() {
        return this.oauthConfigService.oauthToken ? true : false;
    }
    buildSecurityProfileBasedOnOauthToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const oauthProfile = yield this.ssoService.getOauthProfileFromToken(this.oauthConfigService.oauthToken);
            let rbacProfile = {};
            if (this.oauthConfigService.isRbacEnabled) {
                rbacProfile = yield this.serverlessRbacService.getRbacProfileForToken(this.oauthConfigService.oauthToken);
            }
            this.oauthConfigService.oauthProfile = this.createOauthProfileResponseObject(oauthProfile, rbacProfile);
        });
    }
    createOauthProfileResponseObject(oauthProfile, rbacProfile) {
        var _a;
        return {
            token: this.oauthConfigService.oauthToken,
            clientTimeout: this.oauthConfigService.revalidateAfterMin,
            currentRbacProfile: new RbacProfileObject(oauthProfile, rbacProfile).getCombinedOauthRbacProfileObjectForResponse(),
            locale: (_a = oauthProfile.attributes) === null || _a === void 0 ? void 0 : _a.locale,
            logoutUrl: this.oauthConfigService.logoutUrl,
            autoLogoutOnSessionExpired: this.oauthConfigService.autoLogoutOnSessionExpired
        };
    }
    getOauthProfile() {
        return this.oauthConfigService.oauthProfile;
    }
    getApplicationConfiguration() {
        return {
            application: {
                name: this.oauthConfigService.rbacAppName
            },
            revalidateAfterMin: this.oauthConfigService.revalidateAfterMin,
            sessionExpirationAlertInMin: this.oauthConfigService.sessionExpirationAlertInMin,
            longestTimeToLiveHours: this.oauthConfigService.longestTimeToLiveHours,
            autoLogoutOnSessionExpired: this.oauthConfigService.autoLogoutOnSessionExpired
        };
    }
}
ServerlessOauthService.ɵfac = function ServerlessOauthService_Factory(t) { return new (t || ServerlessOauthService)(ɵngcc0.ɵɵinject(OauthConfigService), ɵngcc0.ɵɵinject(SsoService), ɵngcc0.ɵɵinject(ServerlessRbacService)); };
ServerlessOauthService.ɵprov = i0.ɵɵdefineInjectable({ factory: function ServerlessOauthService_Factory() { return new ServerlessOauthService(i0.ɵɵinject(OauthConfigService), i0.ɵɵinject(SsoService), i0.ɵɵinject(ServerlessRbacService)); }, token: ServerlessOauthService, providedIn: "root" });
ServerlessOauthService.ctorParameters = () => [
    { type: OauthConfigService },
    { type: SsoService },
    { type: ServerlessRbacService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ServerlessOauthService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: OauthConfigService }, { type: SsoService }, { type: ServerlessRbacService }]; }, null); })();

class ApplicationConfigurationService {
    constructor(http, route, oauthConfigService, serverlessOauthService) {
        this.http = http;
        this.route = route;
        this.oauthConfigService = oauthConfigService;
        this.serverlessOauthService = serverlessOauthService;
        this.menuHidden = 'false';
        this.pageTitleHidden = 'false';
        this.defaultHierarchyType = 'standard';
        this.appRootContext = '/ui';
    }
    getApplicationConfiguration() {
        // handle serverless applications first
        if (this.oauthConfigService.isServerless) {
            const serverlessData = this.serverlessOauthService.getApplicationConfiguration();
            this.applicationConfiguration = serverlessData;
            return of(serverlessData);
        }
        // ########################################################################
        // Begin legacy OAuth handling (NodeJs Serverside)
        // ########################################################################
        return this.http.get(this.appRootContext + UrlSpace.urls.applicationConfiguration).pipe(map((data) => {
            this.applicationConfiguration = data;
            return data;
        }));
    }
    get applicationConfig() {
        return this.applicationConfiguration;
    }
    get isMenuHidden() {
        this.menuHidden = this.route.snapshot.params.menu ? this.route.snapshot.params.menu : 'false';
        return this.menuHidden;
    }
    get isPageTitleHidden() {
        this.pageTitleHidden = this.route.snapshot.params.page_title ? this.route.snapshot.params.page_title : 'false';
        return this.pageTitleHidden;
    }
    get hierarchyType() {
        this.defaultHierarchyType = this.route.snapshot.queryParams.hierarchyType ?
            this.route.snapshot.queryParams.hierarchyType : this.defaultHierarchyType;
        return this.defaultHierarchyType;
    }
    get rootContext() {
        return this.appRootContext;
    }
    set rootContext(context) {
        this.appRootContext = context;
    }
}
ApplicationConfigurationService.ɵfac = function ApplicationConfigurationService_Factory(t) { return new (t || ApplicationConfigurationService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵinject(OauthConfigService), ɵngcc0.ɵɵinject(ServerlessOauthService)); };
ApplicationConfigurationService.ɵprov = i0.ɵɵdefineInjectable({ factory: function ApplicationConfigurationService_Factory() { return new ApplicationConfigurationService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ActivatedRoute), i0.ɵɵinject(OauthConfigService), i0.ɵɵinject(ServerlessOauthService)); }, token: ApplicationConfigurationService, providedIn: "root" });
ApplicationConfigurationService.ctorParameters = () => [
    { type: HttpClient },
    { type: ActivatedRoute },
    { type: OauthConfigService },
    { type: ServerlessOauthService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ApplicationConfigurationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.ActivatedRoute }, { type: OauthConfigService }, { type: ServerlessOauthService }]; }, null); })();

class TeamsService {
    constructor(http, appConfigService) {
        this.http = http;
        this.appConfigService = appConfigService;
    }
    static getTeamDisplayName(teamName, teamDescription) {
        if (!teamName && !teamDescription) {
            return '';
        }
        if ((teamName && teamName.length > 0) && (teamDescription && teamDescription.length > 0)) {
            return teamDescription + ' ( ' + teamName + ' )';
        }
        if (teamDescription && teamDescription.length > 0) {
            return teamDescription;
        }
        if (teamName && teamName.length > 0) {
            return teamName;
        }
    }
    getHierarchicalTeams(limit, page, application, role, searchTeamName, searchTeamDescription, searchTeamType, sort, hierarchyType) {
        let url = this.appConfigService.rootContext + encodeURI(UrlSpace.urls.teamsHierarchy.replace('{application}', application).replace('{role}', role));
        url = url + '?limit=' + limit + '&page=' + page + '&searchTeamName=' + searchTeamName +
            '&searchTeamDescription=' + searchTeamDescription + '&searchTeamType=' + searchTeamType +
            '&sort=' + sort + '&hierarchyType=' + hierarchyType;
        return this.http.get(url).pipe(map((res) => res.data), catchError(err => of([])));
    }
    getHierarchyTeam(teamName, sourceSystemId, hierarchyType) {
        hierarchyType = hierarchyType || 'standard';
        const searchUrl = { 'search': [{ 'property': 'hierarchy_type', 'value': hierarchyType, 'operator': 'in' }] };
        const url = this.appConfigService.rootContext + UrlSpace.urls.hierarchyTeam.replace('{teamName}', teamName) +
            '?sourceSystemId=' + sourceSystemId + '&search=' + JSON.stringify(searchUrl);
        return this.http.get(url).pipe(map((res) => res.data), catchError(err => of([])));
    }
}
TeamsService.ɵfac = function TeamsService_Factory(t) { return new (t || TeamsService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ApplicationConfigurationService)); };
TeamsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function TeamsService_Factory() { return new TeamsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ApplicationConfigurationService)); }, token: TeamsService, providedIn: "root" });
TeamsService.ctorParameters = () => [
    { type: HttpClient },
    { type: ApplicationConfigurationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TeamsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ApplicationConfigurationService }]; }, null); })();

class RbacService {
    constructor(http, router, route, teamsService, applicationConfigurationService, oauthConfigService, rendererFactory, document) {
        this.http = http;
        this.router = router;
        this.route = route;
        this.teamsService = teamsService;
        this.applicationConfigurationService = applicationConfigurationService;
        this.oauthConfigService = oauthConfigService;
        this.document = document;
        this.access_attributes = [];
        this.DEFAULT_ACCESS_TYPE = 'BLOCKED';
        this._rbacProfileChanged = false;
        this.changeProfileFromQueryParams = new BehaviorSubject(false);
        // Observable navItem source
        this.roleChangeSource = new Subject();
        // Observable navItem stream
        this.roleChangeObservable = this.roleChangeSource.asObservable();
        this.renderer = rendererFactory.createRenderer(null, null);
        this.router.events
            .subscribe((event) => {
            switch (true) {
                case event instanceof NavigationStart: {
                    this.renderer.removeClass(document.body, 'page-loaded');
                    break;
                }
                case event instanceof NavigationCancel:
                case event instanceof NavigationError: {
                    this.renderer.addClass(document.body, 'page-loaded');
                    break;
                }
                case event instanceof NavigationEnd: {
                    this.currentUrl = event.url;
                    if (!this._rbacProfileChanged &&
                        this.route &&
                        this.route.snapshot &&
                        (this.route.snapshot.queryParams.hasOwnProperty('rbac_app_name') || this.route.snapshot.queryParams.hasOwnProperty('rbac_team_name'))) {
                        this.changeProfileFromQueryParams.next(true);
                    }
                    else {
                        this.renderer.addClass(document.body, 'page-loaded');
                    }
                    break;
                }
                default: {
                    break;
                }
            }
        });
    }
    set currentProfile(profile) {
        this.userProfile = profile;
        const prevRole = this.currentRole;
        this.currentRole = profile.current_role;
        this.defaultRole = profile.default_role;
        this.securedObjects = profile.secured_objects;
        this.teams = profile.teams;
        if (prevRole && prevRole.role_name &&
            profile.current_role && profile.current_role.role_name &&
            profile.current_role.role_name !== prevRole.role_name) {
            this.roleChangeSource.next(profile);
        }
        this.changeProfileFromQueryParams.subscribe(res => {
            if (res) {
                this.changeRbacProfile(this.route.snapshot.queryParams);
            }
        });
    }
    get username() {
        return this.userProfile.user_name;
    }
    get profileType() {
        return this.userProfile.profile_type;
    }
    get rbacProfile() {
        return this.userProfile;
    }
    get defaultRole() {
        try {
            return this._defaultRole;
        }
        catch (e) {
            return undefined;
        }
    }
    set defaultRole(value) {
        this._defaultRole = value;
    }
    get defaultRoleName() {
        try {
            return this.userProfile.default_role.role_name;
        }
        catch (e) {
            return undefined;
        }
    }
    get logoutUrl() {
        return this._logoutUrl;
    }
    set logoutUrl(value) {
        this._logoutUrl = value;
    }
    get currentRole() {
        try {
            return this._currentRole;
        }
        catch (e) {
            return undefined;
        }
    }
    set currentRole(value) {
        this._currentRole = value;
    }
    get currentRoleName() {
        try {
            return this.userProfile.current_role.role_name;
        }
        catch (e) {
            return undefined;
        }
    }
    get allRoles() {
        try {
            return this.userProfile.all_roles;
        }
        catch (e) {
            return undefined;
        }
    }
    get selectedTeam() {
        try {
            if (!this.userProfile.selected_team) {
                this.setDefaultSelectedTeam();
            }
            return this.userProfile.selected_team;
        }
        catch (e) {
            return undefined;
        }
    }
    set selectedTeam(team) {
        if (!team) {
            throw Error('The selected teams provided does not exist in the list of available teams, this is not allowed');
        }
        this.userProfile.selected_team = team;
        this.addSelectedTeam();
    }
    get selectedTeamName() {
        const selectedTeam = this.selectedTeam;
        return selectedTeam ? selectedTeam.team_name : null;
    }
    get selectedTeamDisplayName() {
        const selectedTeam = this.selectedTeam;
        return selectedTeam ? TeamsService.getTeamDisplayName(selectedTeam.team_name, selectedTeam.team_description) : null;
    }
    get allSecuredObjects() {
        try {
            return this._securedObjects;
        }
        catch (e) {
            return undefined;
        }
    }
    set securedObjects(value) {
        this._securedObjects = value;
    }
    getSecuredObject(objectName) {
        try {
            for (let i = 0; i < this.userProfile.secured_objects.length; i++) {
                if (objectName === this.userProfile.secured_objects[i].object_name) {
                    return this.userProfile.secured_objects[i];
                }
            }
            return undefined;
        }
        catch (e) {
            return undefined;
        }
    }
    hasSecuredObject(objectName) {
        try {
            let hasObject = false;
            for (let i = 0; i < this.userProfile.secured_objects.length; i++) {
                if (objectName === this.userProfile.secured_objects[i].object_name) {
                    hasObject = true;
                    break;
                }
            }
            return hasObject;
        }
        catch (e) {
            return undefined;
        }
    }
    get defaultAccessType() {
        return this.DEFAULT_ACCESS_TYPE;
    }
    getAccessTypeForSecuredObject(objectName) {
        if (this.hasSecuredObject(objectName)) {
            return this.getSecuredObject(objectName).access_type;
        }
        else {
            return this.defaultAccessType;
        }
    }
    switchCurrentRole(roleName) {
        this.renderer.removeClass(this.document.body, 'page-loaded');
        this.getRbacProfileForRole(roleName).subscribe(data => {
            this.currentProfile = data;
            this.transitionState('/home', false);
            this.setDefaultSelectedTeam();
        }, error => {
            this.renderer.addClass(document.body, 'page-loaded');
            console.log(error);
        });
    }
    switchSelectedTeam(team) {
        this.selectedTeam = team;
    }
    get isRbacProfile() {
        return (RbacService.PROFILE_TYPES.RBAC === this.profileType);
    }
    changeRbacProfile(params) {
        const roleName = params.rbac_role_name ? params.rbac_role_name : '';
        const appName = params.rbac_app_name;
        const rbacTeamName = params.rbac_team_name;
        const rbacTeamSourceSystemId = params.rbac_team_source_system_id;
        const accessAttributes = params.access_attributes;
        const hierarchyType = params.hierarchyType ? params.hierarchyType : this.applicationConfigurationService.hierarchyType;
        this.changeProfileFromQueryParams.next(false);
        if (appName) {
            this.rebuildRbacProfileForRole(appName, roleName, accessAttributes, hierarchyType).subscribe(data => {
                this.currentProfile = data;
                this.appName = appName;
                if (rbacTeamName && rbacTeamSourceSystemId) {
                    this.teamNameAndSourceSystemId(rbacTeamName, rbacTeamSourceSystemId, hierarchyType, this.currentUrl, data, appName, roleName);
                }
                else {
                    this.setDefaultSelectedTeam();
                    this.renderer.addClass(document.body, 'page-loaded');
                    this.transitionState(this.currentUrl, true);
                }
            }, error => {
                console.log(error);
                this.renderer.addClass(document.body, 'page-loaded');
                throw Error('can not rebuild the rbac profile - ' + error);
            });
        }
        else if (rbacTeamName && rbacTeamSourceSystemId) {
            this.renderer.removeClass(this.document.body, 'page-loaded');
            this.teamNameAndSourceSystemId(rbacTeamName, rbacTeamSourceSystemId, hierarchyType, this.currentUrl, null, null, null);
        }
        else {
            this.renderer.addClass(document.body, 'page-loaded');
        }
    }
    get currentAccessAttributes() {
        try {
            return this.userProfile.access_attributes;
        }
        catch (e) {
            return undefined;
        }
    }
    addAttributes(attributes) {
        for (let y = 0; y < attributes.length; y++) {
            for (const key in attributes[y]) {
                if (this.checkAttributeExists(attributes[y], key)) {
                    delete attributes[y][key];
                    if (Object.keys(attributes[y]).length === 0) {
                        attributes.splice(y, 1);
                    }
                }
            }
        }
        for (let i = 0; i < attributes.length; i++) {
            this.access_attributes.push(attributes[i]);
        }
        this.userProfile.access_attributes = this.access_attributes;
    }
    removeAttributes(attributes) {
        this.removeAttributeExists(attributes);
    }
    get teams() {
        return this._teams;
    }
    set teams(value) {
        this._teams = value;
    }
    logout(redirectURL) {
        // handle serverless applications first
        if (this.oauthConfigService.isServerless) {
            window.location.href = this.oauthConfigService.oauthProfile.logoutUrl;
            return;
        }
        // ########################################################################
        // Begin legacy OAuth handling (NodeJs Serverside)
        // ########################################################################
        this.http.get('./auth/logout')
            .toPromise()
            .then(() => {
            const rootContext = this.applicationConfigurationService.applicationConfig.server.rootContext || '';
            const logoutUrl = rootContext + '/logout';
            window.location.href = redirectURL ? redirectURL : logoutUrl;
        });
    }
    get rbacAppName() {
        return this.appName || this.applicationConfigurationService.applicationConfig.application.name;
    }
    // private functions
    // TODO:  update to support serverless handling
    rebuildRbacProfileForRole(appName, roleName, accessAttributes, hierarchyType) {
        let url = this.applicationConfigurationService.rootContext + UrlSpace.urls.rbacUserProfileForRole;
        url = url + '?roleName=' + roleName + '&appName=' + appName;
        if (accessAttributes) {
            url = url + '&accessAttributes=' + accessAttributes;
        }
        else if (hierarchyType) {
            url = url + '&altHirType=' + hierarchyType;
        }
        url = encodeURI(url);
        return this.http.get(url);
    }
    teamNameAndSourceSystemId(rbacTeamName, rbacTeamSourceSystemId, hierarchyType, toState, userProfile, appName, roleName) {
        appName = appName ? appName : this.rbacAppName;
        roleName = roleName ? roleName : this.currentRole.role_name;
        this.teamsService.getHierarchicalTeams(100, 1, appName, roleName, rbacTeamName, '', '', '', hierarchyType)
            .subscribe((response) => {
            if (response.length > 0) {
                for (let i = 0; i < response.length; i++) {
                    if (response[i].team_name.toLowerCase() === rbacTeamName.toLowerCase() &&
                        response[i].source_system_id.toString() === rbacTeamSourceSystemId.toString()) {
                        this.getHierarchyTeam(rbacTeamName, rbacTeamSourceSystemId, hierarchyType, toState, userProfile);
                        break;
                    }
                    else if (i + 1 === response.length) {
                        this.renderer.addClass(document.body, 'page-loaded');
                        this.transitionState(toState, true);
                    }
                }
            }
        }, error => {
            this.renderer.addClass(document.body, 'page-loaded');
            console.error(error);
        });
    }
    getHierarchyTeam(rbacTeamName, rbacTeamSourceSystemId, hierarchyType, toState, userProfile) {
        this.teamsService.getHierarchyTeam(rbacTeamName, rbacTeamSourceSystemId, hierarchyType).subscribe((response) => {
            this.selectedTeam = response.data[0];
            this.renderer.addClass(document.body, 'page-loaded');
            this.transitionState(toState, true);
        }, error => {
            this.renderer.addClass(document.body, 'page-loaded');
            console.error(error);
        });
    }
    setDefaultSelectedTeam() {
        for (let i = 0; i < this.userProfile.teams.length; i++) {
            if (this.userProfile.teams[i].default_team) {
                this.userProfile.selected_team = this.userProfile.teams[i];
                break;
            }
            else {
                this.userProfile.selected_team = null;
            }
        }
        if (!this.userProfile.selected_team) {
            if (this.userProfile.teams.length > 0) {
                const selectedTeam = this.userProfile.teams.sort((a, b) => a.team_name.localeCompare(b.team_name));
                this.userProfile.selected_team = selectedTeam[0];
            }
            else {
                this.userProfile.selected_team = null;
            }
        }
        this.addSelectedTeam();
    }
    addSelectedTeam() {
        const attributes = {};
        this.access_attributes = [];
        attributes.attribute_name = 'selected_team';
        attributes.attribute_value = this.userProfile.selected_team ? this.userProfile.selected_team.team_name : '';
        attributes.attribute_source_system_id = this.userProfile.selected_team ? this.userProfile.selected_team.source_system_id : '';
        this.access_attributes.push(attributes);
        this.userProfile.access_attributes = this.access_attributes;
    }
    getRbacProfileForRole(roleName) {
        const appName = this.rbacAppName;
        let url = this.applicationConfigurationService.rootContext + UrlSpace.urls.rbacUserProfileForRole;
        url = url + '?roleName=' + roleName + '&appName=' + appName;
        url = encodeURI(url);
        return this.http.get(url);
    }
    checkAttributeExists(attribute, key) {
        for (let x = 0; x < this.access_attributes.length; x++) {
            if (this.access_attributes[x].hasOwnProperty(key)) {
                this.access_attributes[x][key] = attribute[key];
                return true;
            }
        }
        return false;
    }
    removeAttributeExists(attributes) {
        for (let x = 0; x < this.access_attributes.length; x++) {
            for (let y = 0; y < attributes.length; y++) {
                for (const key in attributes[y]) {
                    if (this.access_attributes[x].hasOwnProperty(key)) {
                        delete this.access_attributes[x][key];
                        this.access_attributes.splice(x, 1);
                        if (Object.keys(this.access_attributes[x]).length === 0) {
                            this.access_attributes.splice(x, 1);
                        }
                    }
                }
            }
        }
        this.userProfile.access_attributes = this.access_attributes;
    }
    transitionState(toState, skipChange) {
        this.router.navigateByUrl('/', { skipLocationChange: skipChange }).then(() => {
            this._rbacProfileChanged = true;
            this.router.navigateByUrl(toState).then(() => this._rbacProfileChanged = false);
        });
    }
}
RbacService.ɵfac = function RbacService_Factory(t) { return new (t || RbacService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ɵngcc2.Router), ɵngcc0.ɵɵinject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵinject(TeamsService), ɵngcc0.ɵɵinject(ApplicationConfigurationService), ɵngcc0.ɵɵinject(OauthConfigService), ɵngcc0.ɵɵinject(ɵngcc0.RendererFactory2), ɵngcc0.ɵɵinject(DOCUMENT)); };
RbacService.PROFILE_TYPES = {
    OAUTH: 'OAUTH',
    RBAC: 'RBAC'
};
RbacService.ɵprov = i0.ɵɵdefineInjectable({ factory: function RbacService_Factory() { return new RbacService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.Router), i0.ɵɵinject(i2.ActivatedRoute), i0.ɵɵinject(TeamsService), i0.ɵɵinject(ApplicationConfigurationService), i0.ɵɵinject(OauthConfigService), i0.ɵɵinject(i0.RendererFactory2), i0.ɵɵinject(i6.DOCUMENT)); }, token: RbacService, providedIn: "root" });
RbacService.ctorParameters = () => [
    { type: HttpClient },
    { type: Router },
    { type: ActivatedRoute },
    { type: TeamsService },
    { type: ApplicationConfigurationService },
    { type: OauthConfigService },
    { type: RendererFactory2 },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RbacService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ɵngcc2.Router }, { type: ɵngcc2.ActivatedRoute }, { type: TeamsService }, { type: ApplicationConfigurationService }, { type: OauthConfigService }, { type: ɵngcc0.RendererFactory2 }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

class ReauthModalComponent {
    constructor(activeModal, sanitizer, rendererFactory, document) {
        this.activeModal = activeModal;
        this.sanitizer = sanitizer;
        this.document = document;
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    ngOnInit() {
        this.reauthUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.location.origin + window.location.pathname + "auth/reauth");
    }
    checkForToken(frame) {
        if (!this.reauthIframe) {
            return;
        }
        let _this = this;
        try {
            let newToken = this.reauthIframe.nativeElement.contentDocument.getElementById("newToken").innerHTML, newProfile = JSON.parse(this.reauthIframe.nativeElement.contentDocument.getElementById("newProfile").innerHTML);
            _this.activeModal.close({ token: newToken, profile: newProfile });
        }
        catch (err) {
            this.renderer.addClass(document.body, 'page-loaded');
            console.log(err);
        }
    }
    ;
}
ReauthModalComponent.ɵfac = function ReauthModalComponent_Factory(t) { return new (t || ReauthModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbActiveModal), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.DomSanitizer), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.RendererFactory2), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
ReauthModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ReauthModalComponent, selectors: [["reauth-modal"]], viewQuery: function ReauthModalComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.reauthIframe = _t.first);
    } }, decls: 3, vars: 1, consts: [[1, "oauth_modal"], ["id", "oauthIFrame", 3, "src", "load"], ["reauthIframe", ""]], template: function ReauthModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "iframe", 1, 2);
        ɵngcc0.ɵɵlistener("load", function ReauthModalComponent_Template_iframe_load_1_listener() { return ctx.checkForToken(ctx); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("src", ctx.reauthUrl, ɵngcc0.ɵɵsanitizeResourceUrl);
    } }, encapsulation: 2 });
ReauthModalComponent.ctorParameters = () => [
    { type: NgbActiveModal },
    { type: DomSanitizer },
    { type: RendererFactory2 },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
ReauthModalComponent.propDecorators = {
    reauthIframe: [{ type: ViewChild, args: ['reauthIframe', { read: ElementRef },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ReauthModalComponent, [{
        type: Component,
        args: [{
                selector: 'reauth-modal',
                template: "<div class=\"oauth_modal\">\r\n  <iframe #reauthIframe id=\"oauthIFrame\" [src]=\"reauthUrl\" (load)=\"checkForToken(this)\"></iframe>\r\n</div>\r\n"
            }]
    }], function () { return [{ type: ɵngcc3.NgbActiveModal }, { type: ɵngcc4.DomSanitizer }, { type: ɵngcc0.RendererFactory2 }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { reauthIframe: [{
            type: ViewChild,
            args: ['reauthIframe', { read: ElementRef }]
        }] }); })();

class NoAccessComponent {
    constructor(rbacService) {
        this.rbacService = rbacService;
    }
    ngOnInit() {
        this.logOutUrl = this.rbacService.logoutUrl;
    }
}
NoAccessComponent.ɵfac = function NoAccessComponent_Factory(t) { return new (t || NoAccessComponent)(ɵngcc0.ɵɵdirectiveInject(RbacService)); };
NoAccessComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NoAccessComponent, selectors: [["lib-no-access"]], decls: 33, vars: 1, consts: [[1, "no-access"], [1, "access-denied-logo"], [1, "access-denied-content"], [1, "fas", "fa-lock-alt", "access-denied-lock"], [1, "access-denied-word"], [1, "vertical-line"], [1, "unauthorized-support"], ["alt", "Support", "src", "../../../../assets/images/help-unauthorized.png"], [1, "unauthorized-message"], [2, "color", "#007FFF"], [3, "href"]], template: function NoAccessComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "div");
        ɵngcc0.ɵɵelement(4, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div");
        ɵngcc0.ɵɵtext(6, " Access ");
        ɵngcc0.ɵɵelementStart(7, "span", 4);
        ɵngcc0.ɵɵtext(8, "Denied");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(9, " / ");
        ɵngcc0.ɵɵelement(10, "br");
        ɵngcc0.ɵɵelementStart(11, "span", 4);
        ɵngcc0.ɵɵtext(12, "Unauthorized");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(13, " Acesss ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(14, "div", 5);
        ɵngcc0.ɵɵelementStart(15, "div", 6);
        ɵngcc0.ɵɵelement(16, "img", 7);
        ɵngcc0.ɵɵelement(17, "br");
        ɵngcc0.ɵɵtext(18, "Support");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 8);
        ɵngcc0.ɵɵelementStart(20, "p");
        ɵngcc0.ɵɵtext(21, " This is a valid URL, however you do not have authorization to access it.");
        ɵngcc0.ɵɵelement(22, "br");
        ɵngcc0.ɵɵtext(23, " Please contact ");
        ɵngcc0.ɵɵelementStart(24, "span", 9);
        ɵngcc0.ɵɵtext(25, "support");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(26, " for resolution or to request access.");
        ɵngcc0.ɵɵelement(27, "br");
        ɵngcc0.ɵɵelement(28, "br");
        ɵngcc0.ɵɵtext(29, " Alternatively you can refresh the page or ");
        ɵngcc0.ɵɵelementStart(30, "a", 10);
        ɵngcc0.ɵɵtext(31, "Logout");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(32, " and try again to revalidate the access. ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(30);
        ɵngcc0.ɵɵproperty("href", ctx.logOutUrl, ɵngcc0.ɵɵsanitizeUrl);
    } }, styles: [""] });
NoAccessComponent.ctorParameters = () => [
    { type: RbacService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NoAccessComponent, [{
        type: Component,
        args: [{
                selector: 'lib-no-access',
                template: "<div class=\"no-access\">\r\n  <div class=\"access-denied-logo\">\r\n    <div class=\"access-denied-content\">\r\n      <div><i class=\"fas fa-lock-alt access-denied-lock\"></i></div>\r\n      <div>\r\n        Access <span class=\"access-denied-word\">Denied</span> / <br/> <span class=\"access-denied-word\">Unauthorized</span> Acesss\r\n      </div>\r\n      <div class=\"vertical-line\"></div>\r\n      <div class=\"unauthorized-support\"><img alt=\"Support\" src=\"../../../../assets/images/help-unauthorized.png\"><br/>Support</div>\r\n    </div>\r\n  </div>\r\n  <div class=\"unauthorized-message\">\r\n    <p>\r\n      This is a valid URL, however you do not have authorization to access it.<br/>\r\n      Please contact <span style=\"color: #007FFF\">support</span> for resolution or to request access.<br/><br/>\r\n      Alternatively you can refresh the page or <a [href]=\"logOutUrl\">Logout</a> and try again to revalidate the access.\r\n    </p>\r\n  </div>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: RbacService }]; }, null); })();

class OauthService {
    constructor(http, rbacService, appConfigService, oauthConfigService, serverlessOauthService, modalService) {
        this.http = http;
        this.rbacService = rbacService;
        this.appConfigService = appConfigService;
        this.oauthConfigService = oauthConfigService;
        this.serverlessOauthService = serverlessOauthService;
        this.modalService = modalService;
    }
    // Uses http.get() to load data from a single API endpoint
    getOAUTHProfile() {
        // handle serverless applications first
        if (this.oauthConfigService.isServerless) {
            const serverlessProfile = this.serverlessOauthService.getOauthProfile();
            this.oauthProfile = serverlessProfile;
            this.oauthToken = serverlessProfile === null || serverlessProfile === void 0 ? void 0 : serverlessProfile.token;
            this.rbacService.logoutUrl = serverlessProfile === null || serverlessProfile === void 0 ? void 0 : serverlessProfile.logoutUrl;
            this.rbacService.currentProfile = serverlessProfile === null || serverlessProfile === void 0 ? void 0 : serverlessProfile.currentRbacProfile;
            return of(this.oauthProfile);
        }
        // ########################################################################
        // Begin legacy OAuth handling (NodeJs Serverside)
        // ########################################################################
        if (window.location.href.indexOf('selfservice') > -1) {
            this.rbacService.currentProfile = {};
            return of({});
        }
        else {
            const url = this.appConfigService.rootContext + UrlSpace.urls.oAuthProfile;
            return this.http.get(url).pipe(map((data) => {
                this.oauthProfile = data;
                this.oauthToken = data['token'];
                if (this.oauthToken.length === 0) {
                    this.auth();
                }
                else {
                    this.rbacService.logoutUrl = data['logoutUrl'];
                    this.rbacService.currentProfile = JSON.parse(data['currentRbacProfile']);
                }
                return this.oauthProfile;
            }));
        }
    }
    auth() {
        window.location.href = './auth';
    }
    reauth() {
        const modalRef = this.modalService.open(ReauthModalComponent, {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'oauthRenewModal'
        });
        return from(modalRef.result);
    }
    showNoAccess() {
        const noAccessModal = this.modalService.open(NoAccessComponent, {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'oauthRenewModal'
        });
    }
    get oAuthToken() {
        if (window.location.href.indexOf('selfservice') > -1) {
            return null;
        }
        else {
            if (!this.oauthToken || this.oauthToken.length === 0) {
                this.getOAUTHProfile();
            }
            else {
                return this.oauthToken;
            }
        }
    }
    set oAuthToken(token) {
        this.oauthToken = token;
    }
}
OauthService.ɵfac = function OauthService_Factory(t) { return new (t || OauthService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(RbacService), ɵngcc0.ɵɵinject(ApplicationConfigurationService), ɵngcc0.ɵɵinject(OauthConfigService), ɵngcc0.ɵɵinject(ServerlessOauthService), ɵngcc0.ɵɵinject(ɵngcc3.NgbModal)); };
OauthService.ɵprov = i0.ɵɵdefineInjectable({ factory: function OauthService_Factory() { return new OauthService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(RbacService), i0.ɵɵinject(ApplicationConfigurationService), i0.ɵɵinject(OauthConfigService), i0.ɵɵinject(ServerlessOauthService), i0.ɵɵinject(i6$1.NgbModal)); }, token: OauthService, providedIn: "root" });
OauthService.ctorParameters = () => [
    { type: HttpClient },
    { type: RbacService },
    { type: ApplicationConfigurationService },
    { type: OauthConfigService },
    { type: ServerlessOauthService },
    { type: NgbModal }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OauthService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: RbacService }, { type: ApplicationConfigurationService }, { type: OauthConfigService }, { type: ServerlessOauthService }, { type: ɵngcc3.NgbModal }]; }, null); })();

const ConfigToken = new InjectionToken('config');

class SessionInteruptService {
    constructor(rbacService) {
        this.rbacService = rbacService;
    }
    continueSession() {
    }
    stopSession() {
        this.rbacService.logout(this.rbacService.logoutUrl);
    }
}
SessionInteruptService.ɵfac = function SessionInteruptService_Factory(t) { return new (t || SessionInteruptService)(ɵngcc0.ɵɵinject(RbacService)); };
SessionInteruptService.ɵprov = i0.ɵɵdefineInjectable({ factory: function SessionInteruptService_Factory() { return new SessionInteruptService(i0.ɵɵinject(RbacService)); }, token: SessionInteruptService, providedIn: "root" });
SessionInteruptService.ctorParameters = () => [
    { type: RbacService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SessionInteruptService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: RbacService }]; }, null); })();

class SessionExpirationAlertModalComponent {
    constructor(activeModal, sessionInterupter, sessionTimer) {
        this.activeModal = activeModal;
        this.sessionInterupter = sessionInterupter;
        this.sessionTimer = sessionTimer;
    }
    ngOnInit() { }
    continue() {
        this.sessionInterupter.continueSession();
        this.sessionTimer.resetTimer();
        this.activeModal.close();
    }
    logout() {
        this.sessionTimer.stopTimer();
        this.activeModal.close();
        this.sessionInterupter.stopSession();
    }
}
SessionExpirationAlertModalComponent.ɵfac = function SessionExpirationAlertModalComponent_Factory(t) { return new (t || SessionExpirationAlertModalComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.NgbActiveModal), ɵngcc0.ɵɵdirectiveInject(SessionInteruptService), ɵngcc0.ɵɵdirectiveInject(SessionTimerService)); };
SessionExpirationAlertModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SessionExpirationAlertModalComponent, selectors: [["ng-component"]], decls: 20, vars: 3, consts: [[1, "modal-content", "session-alert-notification-modal"], [1, "modal-header"], [1, "modal-title"], [1, "far", "fa-exclamation-triangle"], [2, "float", "right", "color", "#D1A34B"], [1, "modal-body"], [2, "padding-top", "35px"], [2, "font-size", "14px"], [1, "alert-visual"], [1, "modal-footer"], ["type", "button", 1, "btn", "btn-secondary", 3, "click"], ["type", "button", "ngbAutofocus", "", 1, "btn", "btn-primary", 3, "click"]], template: function SessionExpirationAlertModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "h4", 2);
        ɵngcc0.ɵɵelement(3, "i", 3);
        ɵngcc0.ɵɵelementStart(4, "span");
        ɵngcc0.ɵɵtext(5, "Your session is about to time out");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "span", 4);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵpipe(8, "secondsToMinutes");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 5);
        ɵngcc0.ɵɵelementStart(10, "div", 6);
        ɵngcc0.ɵɵelementStart(11, "p", 7);
        ɵngcc0.ɵɵtext(12, "Do you want to stay logged on?");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "div", 8);
        ɵngcc0.ɵɵelement(14, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(15, "div", 9);
        ɵngcc0.ɵɵelementStart(16, "button", 10);
        ɵngcc0.ɵɵlistener("click", function SessionExpirationAlertModalComponent_Template_button_click_16_listener() { return ctx.logout(); });
        ɵngcc0.ɵɵtext(17, " Logout ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "button", 11);
        ɵngcc0.ɵɵlistener("click", function SessionExpirationAlertModalComponent_Template_button_click_18_listener() { return ctx.continue(); });
        ɵngcc0.ɵɵtext(19, " Continue Session ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 1, ctx.sessionTimer.getCount()));
    } }, pipes: function () { return [SecondsToMinutesPipe]; }, encapsulation: 2 });
SessionExpirationAlertModalComponent.ctorParameters = () => [
    { type: NgbActiveModal },
    { type: SessionInteruptService },
    { type: SessionTimerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SessionExpirationAlertModalComponent, [{
        type: Component,
        args: [{
                template: "<div class=\"modal-content session-alert-notification-modal\">\r\n  <div class=\"modal-header\">\r\n    <h4 class=\"modal-title\">\r\n      <i class=\"far fa-exclamation-triangle\"></i>\r\n      <span>Your session is about to time out</span>\r\n      <span style=\"float: right; color: #D1A34B\">{{ sessionTimer.getCount() | secondsToMinutes }}</span>\r\n    </h4>\r\n  </div>\r\n  <div class=\"modal-body\">\r\n    <div style=\"padding-top: 35px\">\r\n      <p style=\"font-size: 14px\">Do you want to stay logged on?</p>\r\n      <div class=\"alert-visual\">\r\n        <i class=\"far fa-exclamation-triangle\"></i>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-secondary\" (click)=\"logout()\">\r\n      Logout\r\n    </button>\r\n    <button\r\n      type=\"button\"\r\n      ngbAutofocus\r\n      class=\"btn btn-primary\"\r\n      (click)=\"continue()\"\r\n    >\r\n      Continue Session\r\n    </button>\r\n  </div>\r\n</div>\r\n"
            }]
    }], function () { return [{ type: ɵngcc3.NgbActiveModal }, { type: SessionInteruptService }, { type: SessionTimerService }]; }, null); })();

class SessionTimerService {
    constructor(config, modalService, rbacService, sessionInterupter, applicationConfig) {
        this.config = config;
        this.modalService = modalService;
        this.rbacService = rbacService;
        this.sessionInterupter = sessionInterupter;
        this.applicationConfig = applicationConfig;
        this.timer = interval(1000);
        this.ngbModalOptions = {
            backdrop: 'static',
            keyboard: false
        };
    }
    setSessionConfig(startTimer) {
        this.startTimerFlag = startTimer;
        if (this.startTimerFlag) {
            this.appConfig = this.applicationConfig.applicationConfig;
            this.sessionTime = this.appConfig.revalidateAfterMin ? this.appConfig.revalidateAfterMin : 30;
            this.sessionExpiryAlertTime = this.appConfig.sessionExpirationAlertInMin ? this.appConfig.sessionExpirationAlertInMin : 3;
            this.longestTimeToLiveHours = this.appConfig.longestTimeToLiveHours ? this.appConfig.longestTimeToLiveHours : 8;
            this.autoLogoutOnSessionExpired = this.appConfig.autoLogoutOnSessionExpired;
            this.timeoutSeconds = this.sessionTime * 60;
            this.sessionExpiryAlertSeconds = this.sessionExpiryAlertTime * 60;
            this.startTimer();
        }
    }
    get timerFlag() {
        return this.startTimerFlag;
    }
    startTimer() {
        this.stopTimer();
        this.count = this.timeoutSeconds;
        this.timerSubscription = this.timer.subscribe(n => {
            if (this.count > 0) {
                this.count--;
                if (this.count === this.sessionExpiryAlertSeconds) {
                    this.modalRef = this.modalService.open(SessionExpirationAlertModalComponent, this.ngbModalOptions);
                }
                if (this.count === 0) {
                    if (this.modalRef) {
                        this.modalRef.close();
                        if (this.autoLogoutOnSessionExpired) {
                            this.sessionInterupter.stopSession();
                        }
                    }
                }
            }
        });
    }
    getCount() {
        return this.count;
    }
    stopTimer() {
        if (this.timerSubscription) {
            this.timerSubscription.unsubscribe();
        }
    }
    resetTimer() {
        this.startTimer();
    }
}
SessionTimerService.ɵfac = function SessionTimerService_Factory(t) { return new (t || SessionTimerService)(ɵngcc0.ɵɵinject(ConfigToken), ɵngcc0.ɵɵinject(ɵngcc3.NgbModal), ɵngcc0.ɵɵinject(RbacService), ɵngcc0.ɵɵinject(SessionInteruptService), ɵngcc0.ɵɵinject(ApplicationConfigurationService)); };
SessionTimerService.ɵprov = i0.ɵɵdefineInjectable({ factory: function SessionTimerService_Factory() { return new SessionTimerService(i0.ɵɵinject(ConfigToken), i0.ɵɵinject(i6$1.NgbModal), i0.ɵɵinject(RbacService), i0.ɵɵinject(SessionInteruptService), i0.ɵɵinject(ApplicationConfigurationService)); }, token: SessionTimerService, providedIn: "root" });
SessionTimerService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [ConfigToken,] }] },
    { type: NgbModal },
    { type: RbacService },
    { type: SessionInteruptService },
    { type: ApplicationConfigurationService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SessionTimerService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [ConfigToken]
            }] }, { type: ɵngcc3.NgbModal }, { type: RbacService }, { type: SessionInteruptService }, { type: ApplicationConfigurationService }]; }, null); })();

class OauthComponent {
    constructor(activatedRoute, router, oauthService, serverlessOauthService, applicationConfigurationService, sessionTimerService) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.oauthService = oauthService;
        this.serverlessOauthService = serverlessOauthService;
        this.applicationConfigurationService = applicationConfigurationService;
        this.sessionTimerService = sessionTimerService;
        this.startTimer = true;
        this.rootContext = '/ui';
        this.serverless = false;
        this.onOauthLoad = new EventEmitter();
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.activatedRoute.queryParamMap
                .subscribe((params) => {
                if (params.get('menu') && params.get('menu') === 'false') {
                    document.body.classList.add('hide-menu');
                }
            });
            this.applicationConfigurationService.rootContext = this.rootContext;
            // handle serverless applications first
            if (this.serverless) {
                const oauthDone = yield this.serverlessOauthService.beginServerlessOauthHandling(this.serverlessConfig);
                if (!oauthDone) {
                    return;
                }
                else {
                    this.router.navigate([], {
                        relativeTo: this.activatedRoute,
                        queryParams: {}
                    });
                }
            }
            forkJoin(this.oauthService.getOAUTHProfile(), this.applicationConfigurationService.getApplicationConfiguration())
                .subscribe(() => {
                this.sessionTimerService.setSessionConfig(this.startTimer);
                this.onOauthLoad.emit(true);
            });
        });
    }
}
OauthComponent.ɵfac = function OauthComponent_Factory(t) { return new (t || OauthComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Router), ɵngcc0.ɵɵdirectiveInject(OauthService), ɵngcc0.ɵɵdirectiveInject(ServerlessOauthService), ɵngcc0.ɵɵdirectiveInject(ApplicationConfigurationService), ɵngcc0.ɵɵdirectiveInject(SessionTimerService)); };
OauthComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OauthComponent, selectors: [["app-oauth"]], inputs: { startTimer: "startTimer", rootContext: "rootContext", serverless: "serverless", serverlessConfig: "serverlessConfig" }, outputs: { onOauthLoad: "onOauthLoad" }, decls: 0, vars: 0, template: function OauthComponent_Template(rf, ctx) { }, encapsulation: 2 });
OauthComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Router },
    { type: OauthService },
    { type: ServerlessOauthService },
    { type: ApplicationConfigurationService },
    { type: SessionTimerService }
];
OauthComponent.propDecorators = {
    startTimer: [{ type: Input }],
    rootContext: [{ type: Input }],
    serverless: [{ type: Input }],
    serverlessConfig: [{ type: Input }],
    onOauthLoad: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OauthComponent, [{
        type: Component,
        args: [{
                selector: 'app-oauth',
                template: ` `
            }]
    }], function () { return [{ type: ɵngcc2.ActivatedRoute }, { type: ɵngcc2.Router }, { type: OauthService }, { type: ServerlessOauthService }, { type: ApplicationConfigurationService }, { type: SessionTimerService }]; }, { startTimer: [{
            type: Input
        }], rootContext: [{
            type: Input
        }], serverless: [{
            type: Input
        }], onOauthLoad: [{
            type: Output
        }], serverlessConfig: [{
            type: Input
        }] }); })();

class OauthInterceptor {
    constructor(http, oauthService, rendererFactory, oauthConfigService, rbacService, timerService, document) {
        this.http = http;
        this.oauthService = oauthService;
        this.oauthConfigService = oauthConfigService;
        this.rbacService = rbacService;
        this.timerService = timerService;
        this.document = document;
        this.rejectionsRes = [];
        this.reauthAttempts = [];
        this.stopDueToReAuthErrors = false;
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    intercept(request, next) {
        // perform pattern matching on request url to see if it should be ignored by this interceptor
        if (this.oauthConfigService.isServerless) {
            const ignore = this.shouldRequestBeIgnored(request);
            if (ignore) {
                return next.handle(request);
            }
        }
        if (this.timerService.timerFlag) {
            this.timerService.resetTimer();
        }
        const authHeader = this.oauthService.oAuthToken;
        if (authHeader) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${authHeader}`
                }
            });
        }
        return next.handle(request).pipe(catchError((error) => {
            if (error instanceof HttpErrorResponse) {
                if (error.status === 401) {
                    return new Observable((observer) => {
                        if (this.rejectionsRes.length > 100) {
                            this.rbacService.logout();
                        }
                        else if (this.rejectionsRes.length > 0) {
                            this.rejectionsRes.push({ obs: observer, req: request, err: error });
                        }
                        else {
                            this.rejectionsRes.push({ obs: observer, req: request, err: error });
                            this.reauthAttempts.push(new Date().getTime());
                            this.removePreviousReAuthAttempts();
                            if (!this.stopDueToReAuthErrors && this.reauthAttempts.length >= 3) {
                                this.stopDueToReAuthErrors = true;
                                this.oauthService.showNoAccess();
                            }
                            else {
                                this.stopDueToReAuthErrors = false;
                            }
                            if (this.stopDueToReAuthErrors) {
                                observer.error(error);
                                return;
                            }
                            this.renderer.removeClass(this.document.body, 'page-loaded');
                            this.oauthService.reauth().subscribe(res => {
                                this.oauthService.oAuthToken = res.token;
                                this.rbacService.currentProfile = res.profile;
                                this.renderer.addClass(document.body, 'page-loaded');
                                while (this.rejectionsRes.length !== 0) {
                                    this.retryRequests(this.rejectionsRes.shift());
                                }
                            }, err => {
                                this.renderer.addClass(document.body, 'page-loaded');
                                while (this.rejectionsRes.length !== 0) {
                                    const rej = this.rejectionsRes.shift();
                                    rej.obs.error(rej.err);
                                }
                            });
                        }
                    });
                }
            }
            return throwError(error);
        }));
    }
    retryRequests(rejReq) {
        rejReq.req = rejReq.req.clone({
            setHeaders: {
                Authorization: `Bearer ${this.oauthService.oAuthToken}`
            }
        });
        this.http.request(rejReq.req).subscribe(res => {
            rejReq.obs.next(res);
        }, error => {
            rejReq.obs.error(error);
        });
    }
    removePreviousReAuthAttempts() {
        for (let i = 0; i < this.reauthAttempts.length; i++) {
            if (this.reauthAttempts[i] < ((new Date()).getTime() - (2 * 60 * 1000))) {
                this.reauthAttempts.splice(i, 1);
            }
        }
    }
    shouldRequestBeIgnored(request) {
        let ignore = false;
        for (const pattern of UrlSpace.urlRegexPatternsToIgnoreInOauthInterceptor) {
            if (request.url.match(pattern)) {
                ignore = true;
                break;
            }
        }
        return ignore;
    }
}
OauthInterceptor.ɵfac = function OauthInterceptor_Factory(t) { return new (t || OauthInterceptor)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(OauthService), ɵngcc0.ɵɵinject(ɵngcc0.RendererFactory2), ɵngcc0.ɵɵinject(OauthConfigService), ɵngcc0.ɵɵinject(RbacService), ɵngcc0.ɵɵinject(SessionTimerService), ɵngcc0.ɵɵinject(DOCUMENT)); };
OauthInterceptor.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: OauthInterceptor, factory: OauthInterceptor.ɵfac });
OauthInterceptor.ctorParameters = () => [
    { type: HttpClient },
    { type: OauthService },
    { type: RendererFactory2 },
    { type: OauthConfigService },
    { type: RbacService },
    { type: SessionTimerService },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OauthInterceptor, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: OauthService }, { type: ɵngcc0.RendererFactory2 }, { type: OauthConfigService }, { type: RbacService }, { type: SessionTimerService }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

class SecondsToMinutesPipe {
    transform(timeInSeconds) {
        let formattedString;
        if (timeInSeconds) {
            let totalHours = 0;
            let totalMinutes = 0;
            let totalSeconds = 0;
            if ((timeInSeconds / 60 / 60) >= 1) {
                totalHours = Math.floor((timeInSeconds / 60 / 60));
                timeInSeconds = (timeInSeconds - (totalHours * 60 * 60));
            }
            if ((timeInSeconds / 60) >= 1) {
                totalMinutes = Math.floor(timeInSeconds / 60);
                timeInSeconds = (timeInSeconds - (totalMinutes * 60));
            }
            if ((timeInSeconds) >= 1) {
                totalSeconds = (timeInSeconds);
            }
            if (totalHours > 0) {
                formattedString = totalHours + ':' + ('0' + totalMinutes).slice(-2) + ':' + ('0' + totalSeconds).slice(-2);
            }
            else {
                formattedString = totalMinutes + ':' + ('0' + totalSeconds).slice(-2);
            }
        }
        return formattedString;
    }
}
SecondsToMinutesPipe.ɵfac = function SecondsToMinutesPipe_Factory(t) { return new (t || SecondsToMinutesPipe)(); };
SecondsToMinutesPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "secondsToMinutes", type: SecondsToMinutesPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SecondsToMinutesPipe, [{
        type: Pipe,
        args: [{
                name: 'secondsToMinutes'
            }]
    }], null, null); })();

class RefreshComponent {
    constructor() { }
    ngOnInit() {
    }
}
RefreshComponent.ɵfac = function RefreshComponent_Factory(t) { return new (t || RefreshComponent)(); };
RefreshComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RefreshComponent, selectors: [["lib-refresh"]], decls: 2, vars: 0, template: function RefreshComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, "refresh works!");
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
RefreshComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RefreshComponent, [{
        type: Component,
        args: [{
                selector: 'lib-refresh',
                template: "<p>refresh works!</p>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, null); })();

const secondaryRoutes = [
    { path: 'RefreshComponent', component: RefreshComponent }
];
class RefreshRoutingModule {
}
RefreshRoutingModule.ɵfac = function RefreshRoutingModule_Factory(t) { return new (t || RefreshRoutingModule)(); };
RefreshRoutingModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: RefreshRoutingModule });
RefreshRoutingModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            RouterModule.forChild(secondaryRoutes)
        ], RouterModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RefreshRoutingModule, [{
        type: NgModule,
        args: [{
                imports: [
                    RouterModule.forChild(secondaryRoutes)
                ],
                exports: [
                    RouterModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(RefreshRoutingModule, { imports: function () { return [ɵngcc2.RouterModule]; }, exports: function () { return [RouterModule]; } }); })();

class RefreshModule {
}
RefreshModule.ɵfac = function RefreshModule_Factory(t) { return new (t || RefreshModule)(); };
RefreshModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: RefreshModule });
RefreshModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            RefreshRoutingModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RefreshModule, [{
        type: NgModule,
        args: [{
                imports: [
                    RefreshRoutingModule
                ],
                declarations: [
                    RefreshComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(RefreshModule, { declarations: [RefreshComponent], imports: [RefreshRoutingModule] }); })();

class StgSecuredObjectConstantsService {
    constructor() {
        this.ACCESS_TYPES = {
            READ_ONLY: 'READ',
            WRITE: 'WRITE',
            BLOCKED: 'BLOCKED'
        };
        this.ATTRIBUTE_NAMES = {
            STG_SECURED_OBJECT: 'stgSecuredObject',
            STG_EXCLUDE_SECURITY_HANDLING: 'stg-exclude-security-handling',
            RBAC_ACCESS_TYPE: 'rbac-access-type',
            READONLY: 'readonly',
            DISABLED: 'disabled'
        };
        this.READ_ONLY_INPUT_TYPES = [
            'date',
            'datetime',
            'datetime-local',
            'email',
            'date',
            'image',
            'month',
            'number',
            'password',
            'range',
            'search',
            'tel',
            'text',
            'time',
            'url',
            'week'
        ];
        this.DIRECTIVES_TO_BLOCK = [
            'ng-click',
            'ng-disabled',
            'ng-sortable'
        ];
    }
}
StgSecuredObjectConstantsService.ɵfac = function StgSecuredObjectConstantsService_Factory(t) { return new (t || StgSecuredObjectConstantsService)(); };
StgSecuredObjectConstantsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: StgSecuredObjectConstantsService, factory: StgSecuredObjectConstantsService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StgSecuredObjectConstantsService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class StgSecuredObjectDirective {
    constructor(templateRef, viewContainer, rbacService, renderer, stgConstantsService) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.rbacService = rbacService;
        this.renderer = renderer;
        this.stgConstantsService = stgConstantsService;
    }
    ngOnInit() {
        this.applyRbacSecurity();
    }
    subscribeToRoleChange() {
        this.subscription = this.rbacService.roleChangeObservable
            .subscribe(userProfile => this.onRoleChanged(userProfile));
    }
    onRoleChanged(userProfile) {
        this.applyRbacSecurity();
    }
    ngOnDestroy() {
        // prevent memory leak when component is destroyed
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    applyRbacSecurity() {
        // if there is no secured object name then add the element to DOM
        if (!this.stgSecuredObject) {
            this.viewContainer.clear();
            this.viewContainer.createEmbeddedView(this.templateRef);
            return;
        }
        const securedObjectName = this.stgSecuredObject;
        let accessType = (this.stgSecuredObjectCustomGetAccessTypeFn) ?
            this.stgSecuredObjectCustomGetAccessTypeFn(securedObjectName) : this.rbacService.getAccessTypeForSecuredObject(securedObjectName);
        // if there is no access type setup then set the default access type
        if (!accessType) {
            accessType = this.rbacService.defaultAccessType;
        }
        // apply the appropriate level of access to the element
        switch (accessType) {
            case this.stgConstantsService.ACCESS_TYPES.WRITE:
                this.applyWriteAccessToElement();
                break;
            case this.stgConstantsService.ACCESS_TYPES.READ_ONLY:
                this.applyReadOnlyAccessToElement(this.templateRef, true);
                break;
            case this.stgConstantsService.ACCESS_TYPES.BLOCKED:
                this.applyBlockedAccessToElement();
                break;
            default:
                throw new Error(('Error determining access type for secured object'));
        }
    }
    /** private function **/
    applyWriteAccessToElement() {
        let element, parentElement, parentElementAccess;
        // clear viewContainer
        this.viewContainer.clear();
        // Adding element to DOM
        this.viewContainer.createEmbeddedView(this.templateRef);
        // Logic to apply read only access to the element whose parent has read-only access
        element = this.templateRef.elementRef.nativeElement.previousElementSibling;
        parentElement = this.templateRef.elementRef.nativeElement.parentElement;
        if (parentElement) {
            parentElementAccess = parentElement.getAttribute(this.stgConstantsService.ATTRIBUTE_NAMES.RBAC_ACCESS_TYPE);
            if (parentElementAccess && parentElementAccess === this.stgConstantsService.ACCESS_TYPES.READ_ONLY) {
                this.applyReadOnlyAccessToElement(element, false);
            }
            else {
                if (element) {
                    element.setAttribute(this.stgConstantsService.ATTRIBUTE_NAMES.RBAC_ACCESS_TYPE, this.stgConstantsService.ACCESS_TYPES.WRITE);
                }
            }
        }
        else {
            if (element) {
                element.setAttribute(this.stgConstantsService.ATTRIBUTE_NAMES.RBAC_ACCESS_TYPE, this.stgConstantsService.ACCESS_TYPES.WRITE);
            }
        }
    }
    /** private function **/
    applyBlockedAccessToElement() {
        // Removing the element from the DOM
        this.viewContainer.clear();
    }
    /** private function **/
    applyReadOnlyAccessToElement(el, isParentElement) {
        let element;
        if (!isParentElement) {
            element = el;
        }
        else {
            this.viewContainer.clear();
            this.viewContainer.createEmbeddedView(this.templateRef);
            element = this.templateRef.elementRef.nativeElement.previousElementSibling;
            // Adding a click listener on the parent
            this.renderer.listen(element, 'click', this.disableClickEvent);
        }
        element.setAttribute(this.stgConstantsService.ATTRIBUTE_NAMES.RBAC_ACCESS_TYPE, this.stgConstantsService.ACCESS_TYPES.READ_ONLY);
        if (this.elementSupportsReadOnly(element)) {
            element.setAttribute('readonly', true);
        }
        else {
            element.setAttribute('disabled', true);
        }
        // applying read only access to children
        this.applyReadOnlySecurityToChildren(element);
    }
    /** private function **/
    elementSupportsReadOnly(element) {
        let supportsReadOnly = false, type;
        type = element.getAttribute('type');
        if (type && this.stgConstantsService.READ_ONLY_INPUT_TYPES.indexOf(type) > -1) {
            supportsReadOnly = true;
        }
        return supportsReadOnly;
    }
    applyReadOnlySecurityToChildren(element) {
        if (element.nodeType !== 8) {
            if (element.children.length > 0) {
                for (let i = 0; i < element.children.length; i++) {
                    // if the child is not a comment
                    if (element.children[i].nodeType !== 8) {
                        const childElement = element.children[i];
                        if (this.isChildEligibleForSecurityHandling(childElement)) {
                            this.applyReadOnlyAccessToElement(childElement, false);
                        }
                    }
                }
            }
        }
    }
    /** private function **/
    isChildEligibleForSecurityHandling(childElement) {
        let isEligible = true, stgSecuredObjectAttribute = childElement.getAttribute(this.stgConstantsService.ATTRIBUTE_NAMES.STG_SECURED_OBJECT), stgExcludeSecurityHandlingAttribute = childElement.getAttribute(this.stgConstantsService.ATTRIBUTE_NAMES.STG_EXCLUDE_SECURITY_HANDLING);
        if (stgSecuredObjectAttribute || stgExcludeSecurityHandlingAttribute) {
            isEligible = false;
        }
        return isEligible;
    }
    disableClickEvent(event) {
        event.preventDefault();
    }
}
StgSecuredObjectDirective.ɵfac = function StgSecuredObjectDirective_Factory(t) { return new (t || StgSecuredObjectDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(RbacService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(StgSecuredObjectConstantsService)); };
StgSecuredObjectDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: StgSecuredObjectDirective, selectors: [["", "stgSecuredObject", ""]], inputs: { stgSecuredObject: "stgSecuredObject", stgSecuredObjectCustomGetAccessTypeFn: "stgSecuredObjectCustomGetAccessTypeFn" } });
StgSecuredObjectDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: ViewContainerRef },
    { type: RbacService },
    { type: Renderer2 },
    { type: StgSecuredObjectConstantsService }
];
StgSecuredObjectDirective.propDecorators = {
    stgSecuredObject: [{ type: Input }],
    stgSecuredObjectCustomGetAccessTypeFn: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StgSecuredObjectDirective, [{
        type: Directive,
        args: [{
                selector: '[stgSecuredObject]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: RbacService }, { type: ɵngcc0.Renderer2 }, { type: StgSecuredObjectConstantsService }]; }, { stgSecuredObject: [{
            type: Input
        }], stgSecuredObjectCustomGetAccessTypeFn: [{
            type: Input
        }] }); })();

class OauthSessionModule {
    static forRoot(config = {
        totalMinutes: 20
    }) {
        return {
            ngModule: OauthSessionModule,
            providers: [
                {
                    provide: ConfigToken,
                    useValue: config
                }
            ]
        };
    }
}
OauthSessionModule.ɵfac = function OauthSessionModule_Factory(t) { return new (t || OauthSessionModule)(); };
OauthSessionModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: OauthSessionModule });
OauthSessionModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: OauthInterceptor,
            multi: true
        },
        StgSecuredObjectConstantsService
    ], imports: [[CommonModule, NgbModule, HttpClientModule, RefreshModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OauthSessionModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, NgbModule, HttpClientModule, RefreshModule],
                declarations: [
                    OauthComponent,
                    SessionExpirationAlertModalComponent,
                    SecondsToMinutesPipe,
                    ReauthModalComponent,
                    NoAccessComponent,
                    StgSecuredObjectDirective
                ],
                providers: [
                    {
                        provide: HTTP_INTERCEPTORS,
                        useClass: OauthInterceptor,
                        multi: true
                    },
                    StgSecuredObjectConstantsService
                ],
                exports: [
                    OauthComponent,
                    SecondsToMinutesPipe,
                    StgSecuredObjectDirective
                ],
                entryComponents: [SessionExpirationAlertModalComponent, ReauthModalComponent, NoAccessComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(OauthSessionModule, { declarations: function () { return [OauthComponent, SessionExpirationAlertModalComponent, SecondsToMinutesPipe, ReauthModalComponent, NoAccessComponent, StgSecuredObjectDirective]; }, imports: function () { return [CommonModule, NgbModule, HttpClientModule, RefreshModule]; }, exports: function () { return [OauthComponent, SecondsToMinutesPipe, StgSecuredObjectDirective]; } }); })();

class UserAdministrationComponent {
    constructor(appConfigService, rbacService, domSanitizer) {
        this.appConfigService = appConfigService;
        this.rbacService = rbacService;
        this.domSanitizer = domSanitizer;
        // @BlockUI() blockUI: NgBlockUI;
        this.count = 0;
    }
    ngOnInit() {
        // this.blockUI.start();
        const appName = this.appConfigService.applicationConfig.application.name, roleName = this.rbacService.currentRoleName, accessAttributes = this.rbacService.currentAccessAttributes, hierarchyType = this.appConfigService.hierarchyType, urlPath = UrlSpace.urls.userAdminUI.replace('{appName}', appName).replace('{roleName}', roleName).replace('{rbac_app_name}', appName).replace('{rbac_role_name}', roleName).replace('{access_attributes}', accessAttributes).replace('{hierarchyType}', hierarchyType), url = this.appConfigService.applicationConfig.urls.base_urls.adams + urlPath;
        this.userAdminUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
UserAdministrationComponent.ɵfac = function UserAdministrationComponent_Factory(t) { return new (t || UserAdministrationComponent)(ɵngcc0.ɵɵdirectiveInject(ApplicationConfigurationService), ɵngcc0.ɵɵdirectiveInject(RbacService), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.DomSanitizer)); };
UserAdministrationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UserAdministrationComponent, selectors: [["user-administration"]], decls: 1, vars: 1, consts: [["id", "user-admin-iframe", "class", "user-admin-iframe", "iframeResizer", "", 3, "src", 4, "ngIf"], ["id", "user-admin-iframe", "iframeResizer", "", 1, "user-admin-iframe", 3, "src"]], template: function UserAdministrationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, UserAdministrationComponent_iframe_0_Template, 1, 1, "iframe", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.userAdminUrl);
    } }, directives: [ɵngcc5.NgIf, ɵngcc6.IFrameResizerDirective], styles: [".user-admin-iframe[_ngcontent-%COMP%]{width:100%}"] });
UserAdministrationComponent.ctorParameters = () => [
    { type: ApplicationConfigurationService },
    { type: RbacService },
    { type: DomSanitizer }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UserAdministrationComponent, [{
        type: Component,
        args: [{
                selector: 'user-administration',
                template: "<!--  <iframe id=\"user-admin-iframe\" class=\"user-admin-iframe\" [src]=\"userAdminUrl\" iframeResizer (load)=\"iframeLoad()\" *ngIf=\"userAdminUrl\"></iframe>-->\r\n<iframe id=\"user-admin-iframe\" class=\"user-admin-iframe\" [src]=\"userAdminUrl\" iframeResizer *ngIf=\"userAdminUrl\"></iframe>\r\n",
                styles: [".user-admin-iframe{width:100%}\n"]
            }]
    }], function () { return [{ type: ApplicationConfigurationService }, { type: RbacService }, { type: ɵngcc4.DomSanitizer }]; }, null); })();

class UserAdministrationModule {
}
UserAdministrationModule.ɵfac = function UserAdministrationModule_Factory(t) { return new (t || UserAdministrationModule)(); };
UserAdministrationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UserAdministrationModule });
UserAdministrationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            IframeResizerModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UserAdministrationModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    UserAdministrationComponent
                ],
                imports: [
                    CommonModule,
                    IframeResizerModule
                ],
                exports: [
                    UserAdministrationComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UserAdministrationModule, { declarations: function () { return [UserAdministrationComponent]; }, imports: function () { return [CommonModule,
        IframeResizerModule]; }, exports: function () { return [UserAdministrationComponent]; } }); })();

/*
 * Public API Surface of oauth
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ApplicationConfigurationService, OauthComponent, OauthConfigService, OauthService, OauthSessionModule, RbacService, SecondsToMinutesPipe, ServerlessOauthService, SessionTimerService, StgSecuredObjectDirective, TeamsService, UserAdministrationComponent, UserAdministrationModule, SsoService as ɵa, ServerlessRbacService as ɵb, ConfigToken as ɵd, SessionInteruptService as ɵe, RefreshModule as ɵf, RefreshRoutingModule as ɵg, RefreshComponent as ɵh, SessionExpirationAlertModalComponent as ɵi, ReauthModalComponent as ɵj, NoAccessComponent as ɵk, StgSecuredObjectConstantsService as ɵl, OauthInterceptor as ɵm };

